import React, {useState} from 'react';
import {NavLink} from 'react-router-dom';
import {useIntl} from 'react-intl';
import {useSelector} from 'react-redux';


import * as styleUtils from '../../../utils/styleUtils';

import PlatformLanguageSwitcher from '../PlatformLanguageSwitcher';
import {I18nMessage} from '../../contexts/I18n';
import {Icon, iconConstants} from '../Icon';
import {OwnPublicationImage} from '../../contexts/Publication';
import {authConstants} from '../../contexts/Auth';
import {myConstants} from '../../modules/My';
import {userSelectors} from '../../contexts/User';

import styles from './MetaNavigation.scss';


function MetaNavigation() {

    const {formatMessage} = useIntl();
    const logout = formatMessage({id: 'meta.logout'});
    const [isExpanded, setIsExpanded] = useState(false);

    const user = useSelector(userSelectors.getUser);

    return (
        <li className={styles.metaNavigation}>
            <div className={styles.wrap}>

                <div className={styles.info}>

                    <div
                        className={styleUtils.toClasses(styles.static, styles.row)}
                        onClick={() => setIsExpanded(!isExpanded)}
                    >
                        <div className={styles.labelWrap}>
                            <em>
                                <I18nMessage id={'meta.loggedIn'}/>
                            </em>
                        </div>
                        <div className={styles.publicationLogoWrap}>
                            <span className={styles.publicationLogo}>
                                <OwnPublicationImage/>
                            </span>
                        </div>
                    </div>

                    {isExpanded && (

                        <div className={styles.flyOut}>

                            <div className={styles.top}>

                                <div className={styles.left}>

                                    <NavLink
                                        className={styles.linkMyAccount}
                                        to={myConstants.NAV_MY_CONTENT}
                                    >
                                        <Icon icon={iconConstants.ICON_USER}/>
                                        <I18nMessage id={'meta.my.account'}/>
                                    </NavLink>

                                </div>
                                <div className={styles.right}>

                                    <PlatformLanguageSwitcher/>

                                </div>

                            </div>

                            <div className={'row'}>

                                <div className={'col'}>
                                    <span className={styles.initials}>
                                        {user.initials}
                                    </span>
                                </div>

                                <div className={'col'}>

                                    <span className={styles.userInfo}>
                                        {user.fullName}
                                    </span>

                                    <span className={styles.userInfo}>
                                        {user.email}
                                    </span>

                                    <NavLink
                                        className={styles.linkLogout}
                                        title={logout}
                                        to={authConstants.NAV_LOGOUT}
                                    >
                                        {logout}
                                    </NavLink>

                                </div>

                            </div>

                        </div>
                    )}
                </div>

            </div>
        </li>
    );
}


MetaNavigation.propTypes = {};


export default MetaNavigation;
